import "./millennium.dependencies"
import { Environment } from "lib/wts.platform"
import { IMillenniumFrame, IRoute, INotificationSource, INotificationItem } from 'lib/millennium.core'
import { loadNotifiers } from "./millennium.modules"
import { MillenniumBrowser, showLogin as showModalLogin } from "./browser/millennium.browser"
import "lib/bootstrap-datepicker.js"
import { Client, getCurrentHost, Session } from "lib/wts.client"
import { Menu } from "lib/wts.ui.overlays"
import { Capacitor } from "@capacitor/core"

export function bootstrapApp() {

	function handleSidebarMouseDown(e: Event) {
		if (!$.contains($('#sidebar')[0], e.target as any))
			hideSideBar()
	}

	function showSideBar() {
		$('#sidebar').css("display", "flex")
		setTimeout(() => {
			$('#sidebar').css("transform", "translateX(0)")
			if (!Capacitor.isNativePlatform()) $('#sidebar .search-box').focus()
		}, 50)
		$('.dimmer').addClass('dimmer-show')
		$(window).on("mousedown.sidebar touchstart.sidebar", handleSidebarMouseDown)
	}

	function hideSideBar(callback?: () => void) {
		$(window).off("mousedown.sidebar touchstart.sidebar")
		if ($('.dimmer').hasClass("dimmer-show")) {
			$('#sidebar').css({ "transform": "translateX(-102%)" })
			//setTimeout(1000, function () { $('#sidebar').hide() });
			$('.dimmer').removeClass('dimmer-show')
			if (callback)
				$('#sidebar').one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function (e) {
					if (callback && typeof callback === "function") callback()
					callback = undefined
				})
		}
	}

	function adjustPreloader() {
		if ($('#preloader').is(":visible")) {
			$('#preloader').css('margin-left', (($(window).width() ?? 0) - ($('#preloader').width() ?? 0)) / 2)
			$('#preloader').css('margin-top', (($(window).height() ?? 0) - ($('#preloader').height() ?? 0)) / 2)
		}
	}

	function showPreloader(value: boolean) {
		if (value) {
			$('.dimmer').addClass('dimmer-show')
			$('#preloader').addClass("windows8")
			$('#preloader').show()
			adjustPreloader()
		}
		else {
			$('.dimmer').removeClass('dimmer-show')
			$('#preloader').hide()
			$('#preloader').removeClass("windows8")
		}
	}

	const notifiersList: (INotificationSource & { currentCount: number, currentList: INotificationItem[] })[] = []

	function updateNotificationCount(notifier: INotificationSource & { currentCount?: number, currentList?: INotificationItem[] }, result: INotificationItem[]) {

		for (const item of result) {
			const found = notifier.currentList && notifier.currentList.find(e => e.key === item.key)
			if (!found) {
				millennium.browser.notify(item.description, "warning")
			}
		}

		notifier.currentList = result
		notifier.currentCount = result.reduce((count, next) => count + 1, 0)

		const el = document.getElementById("notification_count")
		if (el) el.textContent = notifiersList.reduce((sum, next) => sum + next.currentCount, 0).toString()

		localStorage.setItem("last-notify-" + notifier.name, JSON.stringify(result))
	}

	async function startNotifications() {
		const notifiers = await loadNotifiers()
		for (const notifier of notifiers) {
			const instance = notifier.Notifier as INotificationSource & { currentCount: number, currentList: INotificationItem[] }

			const curListJSON = localStorage.getItem("last-notify-" + instance.name)
			if (curListJSON) instance.currentList = JSON.parse(curListJSON)
			notifiersList.push(instance)

			instance.subscribe(updateNotificationCount)
		}
	}

	let keepAliveInterval: any
	function keepAlive() {
		void Client.get("wtssystem/system/now")
	}

	const MENU_ITEMS = Symbol("MENU_ITEMS")

	type HTMLMenuElement = HTMLElement & { [MENU_ITEMS]?: IRoute[] }

	let activeSubmenu: Menu | undefined
	async function handleMenuItemClick(event: Event) {
		if (!(event.target instanceof HTMLElement)) return

		if (event.target.classList.contains("menu-item_active")) {
			event.stopImmediatePropagation()
			event.preventDefault()
			return
		}

		event.target.classList.add("menu-item_active")

		activeSubmenu?.close() //we can´t await so the activeSubmenu don´t get overriten by another event
		activeSubmenu = new Menu()
		const route = await activeSubmenu.show<IRoute | undefined | number>(event.target, (event.target as HTMLMenuElement)[MENU_ITEMS] ?? [])
		event.target.classList.remove("menu-item_active")

		if (route && typeof route === "object")
			loadRoute(route)
	}

	function showMenu(moduleName: string, routes: IRoute[]) {
		const menuBar = document.querySelector(".menu-bar")!
		menuBar.innerHTML = ""

		if (!_routes.find(e => e.nodes?.length)) {
			return
		}

		let mainMenu: HTMLElement & { [MENU_ITEMS]?: IRoute[] } | undefined
		for (const route of routes) {
			if (route.nodes?.length) {
				const item = document.createElement("div") as HTMLMenuElement
				item.innerText = route.text
				item.className = "menu-item"
				item.onpointerdown = handleMenuItemClick
				item.onmouseenter = handleMenuItemClick
				item[MENU_ITEMS] = route.nodes
				menuBar.appendChild(item)
			} else {
				if (!mainMenu) {
					mainMenu = document.createElement("div") as HTMLMenuElement
					mainMenu.className = "menu-item"
					mainMenu.innerText = moduleName || "Geral"
					mainMenu.onpointerdown = handleMenuItemClick
					mainMenu.onmouseenter = handleMenuItemClick
					mainMenu[MENU_ITEMS] = []

					if (menuBar.firstElementChild)
						menuBar.firstElementChild.insertAdjacentElement("beforebegin", mainMenu)
					else
						menuBar.appendChild(mainMenu)
				}
				mainMenu[MENU_ITEMS]?.push(route)
			}
		}
	}

	async function showModule(moduleName: string) {

		if (millennium.browser.currentModuleName === moduleName) return

		const menuPanel = document.querySelector(".side-module-selector")

		menuPanel?.querySelectorAll(".menu-side-item").forEach(e => {
			if (e.getAttribute("data-menu") === moduleName)
				e.classList.add("active")
			else
				e.classList.remove("active")
		})

		_moduleRoutes = _routes.flatMap(e => {
			return ((e.text === moduleName) ? e.nodes : e.nodes === undefined ? e : undefined) ?? []
		})
		showMenu(moduleName, _moduleRoutes)
		millennium.browser.currentModuleName = moduleName
		const homeRoute = _moduleRoutes.find(e => e.text?.indexOf("Portal") > -1)
		if (homeRoute && homeRoute.key && !millennium.browser.hasFrame(homeRoute.key))
			await loadRoute(homeRoute)

		return homeRoute
	}

	function handleSidePanelClick(e: Event) {
		if (!e.target || !(e.target instanceof HTMLElement)) return
		showModule(e.target.getAttribute("data-menu") ?? "")
	}

	function buildModulePanel() {

		const moduleSelector = document.querySelector(".side-module-selector") as HTMLElement
		if (moduleSelector) moduleSelector.innerHTML = ""
		moduleSelector.style.display = ""

		if (!_routes.find(e => e.nodes?.length)) {
			moduleSelector.style.display = "none"
			return
		}

		const createModuleItem = (route: IRoute | { text: string }, targetModule?: string, active = false) => {
			const item = document.createElement("button")
			item.title = route.text
			item.className = "menu-side-item"
			const icon = document.createElement("img")
			icon.src = "images/" + route.text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(" ", "_") + ".svg"
			icon.onerror = (e) => { checkShowPanel(); if (e instanceof Event) (e.target as HTMLImageElement).src = "images/generic.svg" }
			icon.onload = (_) => { checkShowPanel() }
			item.appendChild(icon)
			const text = document.createElement("label")
			text.innerText = route.text
			item.onclick = handleSidePanelClick
			item.setAttribute("data-menu", targetModule ?? route.text)
			item.appendChild(text)
			if (active) item.classList.add("active")
			return item
		}

		let itemCount = 1
		if (_routes.length) {
			moduleSelector?.appendChild(createModuleItem({
				text: "Home"
			}, "", true))
		}
		for (const route of _routes)
			if (route.nodes?.length) {
				itemCount++
				moduleSelector?.appendChild(createModuleItem(route))
				//menuPanel?.appendChild(createItem())
			}

		//show when all images are loaded
		const checkShowPanel = () => {
			itemCount--
			if (itemCount === 0)
				setTimeout(() => moduleSelector?.classList.add("side-module-selector_ready"), 50)
		}

		//or when there is a timeout
		setTimeout(() => moduleSelector?.classList.add("side-module-selector_ready"), 500)
	}

	let _routes: IRoute[]
	let _moduleRoutes: IRoute[]
	let _startupUrl: string
	async function loginSuccess() {
		$("#login-div").blur()

		const navTree = $('.sidebar .menu-tree')

		navTree.empty()
		$("#licence_type").attr("disabled", "true")

		if (!millennium.browser.isEmbedded) {
			try {
				const versions = await millennium.browser.getVersion()
				$(".versionOmnichannel").text(versions["omni"] ?? "")
				$(".versionMillennium").text(versions["millennium"] ?? "")
			} catch { }

			_routes = await millennium.browser.getRoutes()
			$('#sidebar').hide()

			buildModulePanel()

			navTree.treeview({
				data: _routes, levels: 1,
				onhoverColor: "rgba(255,255,255,0.3)",
				selectedBackColor: "var(--accent-color)",
				collapseIcon: "far fa-chevron-down",
				expandIcon: "far fa-chevron-right",
				nodeIcon: "",
				emptyIcon: "",
				onNodeSelected: nodeSelected
			})

			clearInterval(keepAliveInterval)
			const keepAliveTime = 60000 * 2 + Math.round(Math.random() * 60000)
			console.info("KEEP_ALIVE_TIME:", keepAliveTime)
			keepAliveInterval = setInterval(keepAlive, keepAliveTime)

			$("#login-div").remove()
		}

		showPreloader(false)
		hideLogin()

		try {
			if (_startupUrl) {

				let routeKey = _startupUrl

				_startupUrl = ""

				let routeObj
				const paramsIdx = routeKey.indexOf("?")
				if (paramsIdx >= 0) {
					routeObj = JSON.parse(decodeURI(routeKey.substr(paramsIdx + 1)))
					routeKey = routeObj.target ?? routeKey.substr(0, paramsIdx)
				}

				while (routeKey.charAt(0) === "#" || routeKey.charAt(0) === "/")
					routeKey = routeKey.substring(1)

				if (routeKey?.trim()) {
					if (!routeObj) routeObj = findRoute(routeKey)?.route
					if (routeObj) {
						const curFrame = millennium.browser.createFrame()
						await loadRoute(routeObj, curFrame)
					}
				}

			} else if ($("#header").find("ul").children().length === 0) {
				const curFrame = millennium.browser.createFrame()
				await millennium.browser.load(curFrame, undefined, { target: "home", caption: "Millennium" }, null)
			}
		}
		catch (e) {
			console.error("Error loading startup URL " + _startupUrl, e)
		}

		if (!millennium.browser.isEmbedded) {
			setTimeout(() => millennium.browser.notify("Login concluído", "success"), 0)
			void startNotifications()
		}
	}

	let currentLoginCallback: ((host: string, userName: string, password: string) => Promise<void>) | undefined

	async function defaultFinishLogin(host: string, userName: string, password: string) {
		if (localStorage) {
			localStorage.setItem('userName', userName)
			localStorage.setItem('defaultHost', host)
		}
		if (!millennium.browser.inLogin) {
			showPreloader(true)
			try {
				let appName = localStorage.getItem("appname") || "B5WIN32"
				let licenceName = localStorage.getItem("licencename") || "retag"

				const licenceEl = $("#licence_type")[0] as HTMLSelectElement
				if (licenceEl && licenceEl.selectedIndex >= 0) {
					licenceName = licenceEl.options[licenceEl.selectedIndex].value
					appName = licenceName.toUpperCase()
					if (licenceName === "loja" || licenceName === "retag")//legacy
						appName = "B5WIN32"

					localStorage.setItem("appname", appName)
					localStorage.setItem("licencename", licenceName)
				}

				await millennium.browser.login(appName, licenceName, getCurrentHost(), userName, password)
				await loginSuccess()
			}
			catch (e: any) {
				showPreloader(false)
				throw e
			}
		}
	}

	function notificationButtonClick() {
		for (const n of notifiersList) n.action()
	}

	async function loginClick() {
		if (currentLoginCallback)
			try {
				await currentLoginCallback($('#hostname').val() as string, ($("#username").val() as string), ($("#password").val() as string))
				currentLoginCallback = undefined
			} catch (e: any) {
				millennium.browser.notify(e, "danger")
				throw e
			}
	}

	function currentFrame() {
		return $("#header").find("ul").children(".active").data("mln-frame-instance") as IMillenniumFrame
	}

	async function loadRoute(route: IRoute, frame?: IMillenniumFrame) {
		const routeObj = route.key && findRoute(route.key)
		if (routeObj) {
			const moduleInfo = await showModule(routeObj.path[0]?.text ?? "")
			if (moduleInfo?.key === route.key) return
		}

		return millennium.browser.load(frame ?? currentFrame(), route.key, route.target ? route : undefined)
	}

	function nodeSelected(args: any, node: IRoute & { _client?: boolean }) {
		hideSideBar(() => loadRoute(node))
	}

	function findRoute(key: string): { route: IRoute, path: IRoute[] } | undefined {
		function findNode(children: IRoute[] | undefined): { route: IRoute, path: IRoute[] } | undefined {
			if (children)
				for (let x = 0; x < children.length; x++)
					if (children[x].nodes && children[x].nodes?.length) {
						const node = findNode(children[x].nodes)
						if (node) {
							node.path.unshift(children[x])
							return node
						}
					}
					else if (children[x].key?.localeCompare(key, undefined, { sensitivity: 'accent' }) === 0) {
						return { route: children[x], path: [] }
					}
		}
		return findNode(_routes)
	}

	function hideLogin() {
		$("#login-div").hide()
		$("#content-frame").addClass("visible")
		//we need to remove for safety and because of a (very) wird chrome behaviour that
		//starts triggering keydown events for all over the place
		$("#password").remove()
	}

	function handleLoginDone(session?: Session) {
		if (session)
			localStorage.setItem('sessionData', JSON.stringify(session.loginData))
		hideLogin()
	}

	function handleBlurHostname() {
		localStorage.setItem('defaultHost', $('#hostname').val() as string)
		void loadLicenceTypes()
	}

	async function loadLicenceTypes() {
		const licenceEl = $("#licence_type")
		if (licenceEl.children().length > 0) return

		const curName = Capacitor.isNativePlatform() ? "omni" : localStorage.getItem("licencename") || "omni"
		const result = await Client.get<any>("millenium:wtssystem.users.GetLicenceGroups", {}, { anonymous: true, licenceType: "mgt" })
		for (const item of result.value) {
			const option = document.createElement("option")
			option.textContent = item.DESCRIPTION
			option.value = item.NAME
			option.setAttribute("data-type", item.TYPE)
			option.selected = curName === item.NAME
			option.style.background = "var(--command-color)"
			option.style.color = "white"
			option.style.padding = "5px"
			licenceEl.append(option)
		}
	}

	function showInitialLogin(blank = false, message = "", callback = defaultFinishLogin) {
		if (currentLoginCallback) throw Error("Login already in progress")

		clearInterval(keepAliveInterval)
		showPreloader(false)
		currentLoginCallback = callback
		$("#password").remove()
		//creates the pwd element
		$("#pwd-group").append($(`<input autocomplete="off" class="light-placeholder" id="password" type="password" placeholder="Senha" style="border:none;background:none;width:100%;color:black"/>`))
		$("#login-message").text(message)

		if (!blank) $("#content-frame").removeClass("visible")

		$("#login_anim").addClass("show-fadein")
		$("#login-div").show()

		const hasUser = $("#username").val() !== ""

		if (localStorage) {
			$("#hostname").val((blank) ? "" : localStorage.getItem("defaultHost") || "")
			$("#username").val((blank) ? "" : localStorage.getItem("userName") || "")
			$("#password").val("")
		}

		if (!blank && hasUser) {
			$("#username").attr("readonly", "true")
			$("#password").focus()
		} else {
			$("#username").removeAttr("readonly")
			$("#username").focus()
		}

		setTimeout(function () { $("#login_anim").removeClass("show-fadein") }, 1000)

		// if (Capacitor.isNativePlatform()) $("#licence_type").hide()

		void loadLicenceTypes()
	}

	async function logout() {
		try {
			await millennium.browser.logout()
		} catch {

		}
		window.location.reload()
	}

	async function showUserOptions() {
		const menu = new Menu()
		const result = await menu.show(document.querySelector("#usr-img") as HTMLElement, [
			millennium.browser.userName,
			"-",
			"Logout"
		])

		if (result === 2) {
			logout()
		}
	}

	function filterRoutes(text: string): IRoute[] {

		function search(nodes: IRoute[]) {
			const searchResult = { nodes: [] as IRoute[], hasLeaf: false }
			for (const node of nodes) {
				if (node.nodes && node.nodes.length) {
					const nodeResult = search(node.nodes)
					searchResult.hasLeaf = searchResult.hasLeaf || nodeResult.hasLeaf
					if (nodeResult.hasLeaf)
						searchResult.nodes.push({ ...node, nodes: nodeResult.nodes })
				}
				else if (node.text?.match(searchRegex)) {
					searchResult.hasLeaf = true
					searchResult.nodes.push(node)
				}
			}
			return searchResult
		}

		const searchRegex = new RegExp(text, "i")
		const result = search(_routes)
		if (result.hasLeaf)
			return result.nodes
		else
			return []
	}

	let _searchTimeout: any
	function handleSidebarSearch(e: Event) {
		clearTimeout(_searchTimeout)
		_searchTimeout = setTimeout(function () {
			const navTree = $('.sidebar .menu-tree')
			navTree.treeview("remove")
			const value = (e.target as HTMLInputElement).value
			const filteredRoutes = filterRoutes(value)
			navTree.treeview({
				data: filteredRoutes, levels: value ? 10 : 1,
				onhoverColor: "rgba(255,255,255,0.3)",
				selectedBackColor: "var(--accent-color)",
				collapseIcon: "far fa-chevron-down",
				expandIcon: "far fa-chevron-right",
				nodeIcon: "",
				emptyIcon: "",
				onNodeSelected: nodeSelected
			})
		}, 50)
	}

	function setupUI() {

		if (!(millennium && millennium.browser && millennium.browser.isEmbedded)) {
			$('.mln-module-header').show()
			$('#usr-img').attr("src", "https://www.gravatar.com/avatar?d=mm&s=28")
		}
		else {
			$('.mln-module-header').hide()
		}

		if (Environment.isMobile)
			window.document.body.classList.add("mobile")

		if (millennium.browser?.isEmbedded)
			window.document.body.classList.add("mln-embedded")

		$('#menu-btn').click((e) => {
			showSideBar()
			e.stopPropagation()
		})

		if (location.protocol === "file:" || Capacitor.isNativePlatform()) {
			$('.mln-host-input').show()
			$('#hostname').on("blur", handleBlurHostname)
		}

		$("#login").on("click", loginClick)

		$("#teste").on("click", () => {
			millennium.browser.switchUser()
		})

		$("#usr-img").on("click", showUserOptions)

		$("#logout").on("click", logout)

		$("#login-div").on("keydown", (e) => {
			if (e.keyCode === 13) $("#login").trigger("click")
		})

		$("#sidebar-close").on("click", () => hideSideBar())
		$("#sidebar-search").on("keyup", handleSidebarSearch)
		$("#sidebar-search").on("search", handleSidebarSearch)

		$("#notification_button").on("click", notificationButtonClick)

		function getErrorMessage(obj: unknown) {
			if (!obj) return
			const message = (obj instanceof Error ? obj.message : String(obj)) || ""
			if (message.substring(0, 5) === "show:")
				return message.substring(5)
		}

		window.addEventListener("error", event => {
			const message = getErrorMessage(event.error)
			if (message)
				millennium.browser.notify(message, "danger")
		})

		window.addEventListener("unhandledrejection", event => {
			const message = getErrorMessage(event.reason)
			if (message)
				millennium.browser.notify(message, "danger")
		})

		document.addEventListener("touchstart", function () { }, false)
		document.addEventListener("contextmenu", function (e: Event) {
			e.preventDefault()
		}, false)

		const browserController = new MillenniumBrowser()

		browserController.onLoginDone.subscribe(handleLoginDone)

		var authInProcess = false
		browserController.onAuthFail.subscribe(async (options) => {
			if (authInProcess) return

			authInProcess = true
			try {
				localStorage.setItem('sessionData', '')
				document.querySelector("#login-div")?.classList.add("login-auth-fail")

				if (options && options.blank) {
					const loginInfo = await showModalLogin(options)
					if (loginInfo)
						await defaultFinishLogin(getCurrentHost(), loginInfo.username, loginInfo.password)
				}
				else if (!millennium.browser.isEmbedded) {
					do {
						var loginInfo = await showModalLogin()
						if (loginInfo)
							try {
								await defaultFinishLogin(getCurrentHost(), loginInfo.username, loginInfo.password)
							} catch (e: any) {
								millennium.browser.notify(e, "warning")
								loginInfo = undefined
							}
					} while (!loginInfo)
				}
				else {
					try {
						const sessionId = await millennium.browser.getSessionId()
						const licenceType = sessionId.split('|')[4]
						await millennium.browser.joinSession(location.protocol + "//" + location.host, sessionId, {}, true, licenceType)
					} catch (e) {
						console.error(e)
					}
				}
			} finally {
				authInProcess = false
			}
		})

		//let the existing (native) implementation override ours
		if (millennium.browser) {
			for (const hook in millennium.browser)
				if (millennium.browser.hasOwnProperty(hook))
					(browserController as any)[hook] = (millennium.browser as any)[hook]
		}

		millennium.browser = browserController

		document.querySelector(".mln-mainbody")?.classList.add("mln-mainbody_ready")
	};

	async function startup(startupPage: string) {

		hideLogin()
		_startupUrl = startupPage
		const rawSessionData = localStorage.getItem('sessionData')
		let sessionData
		try {
			sessionData = rawSessionData && JSON.parse(rawSessionData)
		} catch {
			sessionData = ""
		}
		if (!millennium.browser.isEmbedded) {
			if (!sessionData)
				showInitialLogin()
			else {
				showPreloader(true)
				try {
					await millennium.browser.joinSession(getCurrentHost(),
						sessionData.session,
						sessionData,
						true,
						localStorage.getItem("appname") || "",
						localStorage.getItem("licenceName") || "")

					await loginSuccess()
				} catch {
					showInitialLogin()
				}
			}
		} else {
			try {
				const sessionId = await millennium.browser.getSessionId()
				await millennium.browser.joinSession(location.protocol + "//" + location.host,
					sessionId,
					{},
					true)
				await loginSuccess()
			} catch (e) {
				console.error(e)
			}
		}
	}

	//wireup all events
	setupUI()
	if (!(window as any)['WebComponentsReady'])
		void startup(location.hash)
	else window.addEventListener('WebComponentsReady', (e) => {
		void startup(location.hash)
	})
}

window.addEventListener("load", () => bootstrapApp())
